import FieldSuggestions from "../component/FieldSuggestions";

export class FieldComponentPlugin {
    renderMap = (originalMember, instance) => ({
        ...originalMember,
        'suggestions': this.renderSuggestions.bind(instance)
    });

    renderSuggestions() {
        const {
            attr,
            events,
            setRef,
            isDisabled = false,
            suggestionsConfig
        } = this.props;

        return (
            <FieldSuggestions
              attr={ attr }
              events={ events }
              setRef={ setRef }
              isDisabled={ isDisabled }
              suggestionsConfig={ suggestionsConfig }
            />
        )
    }
}

const { renderMap } = new FieldComponentPlugin();

export default {
    'Component/Field/Component': {
        'member-property': {
            renderMap
        }
    }
}